import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { updatePostAction, getSinglePostAction, updatePostStatusAction } from '../../../../module/action/Post';
import { useDispatch, useSelector } from 'react-redux';
import { getAllCategoriesAction, getCategoriesPostAction } from '../../../../module/action/Category';
import { getBookVolumesAction } from '../../../../module/action/Book';
import PostFormData from '../../components/PostFormData';
import DropDownIcon from '../../../../Assets/Icons/DropDownIcon';
import TicIcon from '../../../../Assets/Icons/TicIcon';
import DraftIcon from '../../../../Assets/Icons/DraftIcon';
import { toast } from 'react-toastify';
import Spinner from '../../../../Constants/Spinner';
import { DEFAULT_POST_CONTENT } from '../../utils/constants';

function EditPost() {
  const dispatch = useDispatch();
  const navigation = useNavigate();

  const [editState, setEditState] = useState(false);

  const bookData = useSelector(e => e.Book.bookData);
  const volumesData = useSelector(e => e.Book.volumesData);
  const singlePost = useSelector(e => e.Post.singlePost);
  const isPostLoading = useSelector(e => e.Post.singlePostLoader);

  const getCategoriesPostData = useSelector(e => e.Category.getCategoriesPostData);
  const getAllCategoriesOfBook = useSelector(e => e.Category.allCategoriesOfBook);

  const [getBookPostData, setGetBookPost] = useState([]);

  const [categoriesArr, setCategoriesArr] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);

  const [bookId, setBookId] = useState('');

  const [audioName, setAudioName] = useState('');

  const [bookObj, setBookObj] = useState({
    book: '',
    volume: '',
  });

  const [postObj, setPostObj] = useState({
    reference: '',
    post_number: '',
    content: DEFAULT_POST_CONTENT,
    recitation_audio: '',
  });
  const [isPostObjSynced, setIsPostObjSynced] = useState(false);

  const [publishLoader, setPublishLoader] = useState(false);
  const [draftLoader, setDraftLoader] = useState(false);
  const [disabled, setDisable] = useState(false);
  useEffect(() => {
    if (publishLoader || draftLoader) {
      setDisable(true);
    } else if (!postObj.reference && !postObj.post_number && !postObj.content) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [postObj, publishLoader, draftLoader]);
  const getCat = refiD => {
    dispatch(getCategoriesPostAction(bookId, refiD));
  };

  useEffect(() => {
    const url = new URL(window.location);
    const id = url.searchParams.get('id');

    dispatch(getSinglePostAction(id));
  }, []);

  useEffect(() => {
    if (getAllCategoriesOfBook?.data) {
      setCategoriesArr(getAllCategoriesOfBook.data);
    }
  }, [getAllCategoriesOfBook]);

  useEffect(() => {
    if (getCategoriesPostData?.data?.length > 0) {
      setCategoriesArr(state => [...state, getCategoriesPostData.data]);
    }
  }, [getCategoriesPostData]);

  useEffect(() => {
    if (bookId) {
      dispatch(getBookVolumesAction(bookId));
    }
  }, [bookId]);

  useEffect(() => {
    if (!singlePost) return;

    setBookObj({
      book: singlePost.book,
      volume: singlePost.volume,
    });
    setPostObj({
      reference: singlePost.reference,
      post_number: singlePost.post_number,
      content: singlePost.content,
      preview: singlePost.preview,
      recitation_audio: '',
    });
    setIsPostObjSynced(true);
    setBookId(singlePost.book);
    setSelectedCategories([...singlePost.categories]);
    dispatch(getAllCategoriesAction(singlePost.book, singlePost.categories));

    // let audiotitle = singlePost.
    setAudioName(singlePost.recitation_audio);
    setEditState({
      reference: singlePost.reference,
      post_number: singlePost.post_number,
      content: singlePost.content,
      preview: singlePost.preview,
      recitation_audio: singlePost.recitation_audio,
    });
  }, [singlePost]);

  const backToList = () => {
    // navigation('/all-posts');
  };
  const afterStatusUpdate = (boolean, status) => {
    if (status === 'draft') {
      setDraftLoader(boolean);
      navigation('/draft');
    } else {
      setPublishLoader(boolean);
      navigation('/all-posts');
    }
  };
  const confirmPost = setConfirmLoader => {
    let obj = {
      ...postObj,
      ...bookObj,
      categories: selectedCategories,
      status: singlePost.status,
    };

    dispatch(
      updatePostAction(
        obj,
        singlePost._id,
        backToList,
        singlePost.status,
        false,
        setConfirmLoader,
        obj.book,
        obj.volume,
        obj.categories,
        false,
        false,
        false
      )
    );
    setDisable(false);
  };
  const updateStatus = status => {
    let obj = {
      post: [singlePost._id],
      status: status,
    };
    toast.success(status === 'draft' ? 'Post saved in draft' : 'Post published');
    dispatch(updatePostStatusAction(obj, bool => afterStatusUpdate(bool, status), true));
  };
  return (
    <div className="NewPost my-12 px-8 innerDashboard">
      <div className="header  justify-between flex">
        <div className="flex align-middle items-center">
          <h2 className="text-[32px] font-extrabold ">Update Post</h2>
        </div>
      </div>
      <div className="formPost mt-[56px]">
        <div className="chooseBook mb-[32px]">
          <div className="flex justify-between items-center">
            <p className='mb-6 font-bold font-["Poppins-ExtraBold"] '>1. Choose Book</p>
          </div>
          <div className="bookDetail flex flex-wrap items-center justify-between px-8 bg-[#eef2f0] rounded-s-lg py-6 w-full">
            <div className="md:w-[32%] w-full">
              <p className="text-sm text-black font-semibold">Book Name</p>
              <label className="w-full h-[56px] relative flex items-center  mt-[16px]">
                <DropDownIcon className="pointer-events-none absolute z-[1] right-[22px]" />

                <select
                  value={bookObj.book}
                  className="selectInput rounded-xl text-[14px]  border-[1px] border-[#dde4de] h-full  w-full px-6 outline-none text-[#7b867c]"
                  onChange={ev => {
                    let obj = { ...bookObj };
                    obj.book = ev.target.value;
                    obj.volume = '';
                    setBookObj(obj);
                    setBookId(ev.target.value);

                    setCategoriesArr([]);
                    setSelectedCategories([]);
                    dispatch(getCategoriesPostAction(bookId, ''));
                  }}>
                  <option className="hidden">Choose book</option>
                  {bookData &&
                    bookData.map((a, i) => (
                      <option key={i} value={a._id}>
                        {a.bookName}
                      </option>
                    ))}
                </select>
              </label>
            </div>
            <div className="md:w-[32%] w-full">
              <p className="text-sm text-black font-semibold">Choose Volume</p>
              <label className="w-full h-[56px] relative flex mt-[16px] items-center">
                <DropDownIcon className="pointer-events-none absolute z-[1] right-[22px]" />

                <select
                  value={bookObj.volume}
                  disabled={!volumesData}
                  className="selectInput rounded-xl  text-[14px] border-[1px] border-[#dde4de] h-full  w-full px-6 outline-none text-[#7b867c]"
                  onChange={ev => {
                    let obj = { ...bookObj };
                    obj.volume = ev.target.value;

                    setBookObj(obj);
                  }}>
                  <option className="hidden">Choose Volume</option>
                  {volumesData &&
                    volumesData.map((a, i) =>
                      a.volume_name ? (
                        <option key={i} value={a._id}>
                          {a.volume_name}
                        </option>
                      ) : null
                    )}
                </select>
              </label>
            </div>
            <div className="w-[32%] md:block hidden"></div>
          </div>
        </div>
        {categoriesArr.length > 0 && (
          <div className="chooseBook mb-[32px]">
            <div className="flex justify-between flex-wrap items-center md:flex-row flex-col">
              <p className='mb-6 font-bold md:w-auto w-full font-["Poppins-ExtraBold"]'>2. Coose Location</p>
            </div>
            <div className="locationDetail flex flex-wrap items-center justify-start px-8 bg-[#eef2f0] rounded-s-lg py-6 w-full">
              {categoriesArr.map((categorieArr, i) => (
                <div className="lg:w-[24%] md:w-[48%] w-full ml-2 mt-2">
                  <p className="text-sm text-black font-semibold">{(i === 0 ? 'Parent ' : 'Sub-') + 'Category'}</p>
                  <label className="w-full h-[56px] relative flex mt-[16px] items-center">
                    <DropDownIcon className="pointer-events-none absolute z-[1] right-[22px]" />
                    <select
                      value={selectedCategories[i]}
                      className="selectInput rounded-xl  text-[14px] border-[1px] border-[#dde4de] h-full  w-full px-6 outline-none text-[#7b867c]"
                      onChange={ev => {
                        setSelectedCategories(state => {
                          let arr = state.slice(0, i + 1);
                          arr[i] = ev.target.value;
                          return arr;
                        });

                        setCategoriesArr(state => state.slice(0, i + 1));

                        getCat(ev.target.value);
                      }}>
                      <option className="hidden">Select</option>
                      {categorieArr.map((a, i) => (
                        <option key={i} value={a._id}>
                          {a.category_name}
                        </option>
                      ))}
                    </select>
                  </label>
                </div>
              ))}
            </div>
          </div>
        )}
        <div className="postDetail mb-[32px]">
          <div className="flex justify-between items-center">
            <p className='mb-6 font-bold font-["Poppins-ExtraBold"]'>3. Post Details</p>
          </div>
          <PostFormData
            postObj={postObj}
            isPostLoading={isPostLoading || !isPostObjSynced}
            setPostObj={setPostObj}
            audioName={audioName}
            setAudioName={setAudioName}
            getBookPostData={getBookPostData}
            formFunction={confirmPost}
            editState={editState}
          />

          <div className="mt-6 flex items-center flex-wrap">
            <button
              disabled={disabled}
              className="rounded-xl md:mr-4 md:mb-0 mb-4 text-white bg-[#2a9134] py-3.5 px-12 flex items-center justify-center md:w-auto w-[100%] disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={() => updateStatus('post')}>
              {publishLoader ? (
                <Spinner />
              ) : (
                <>
                  <TicIcon stroke="#fff" />
                  Save Edits
                </>
              )}
            </button>
            <button
              disabled={disabled}
              className="rounded-xl text-white bg-black py-3.5 px-12 flex items-center justify-center md:w-auto w-[100%] disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={() => updateStatus('draft')}>
              {draftLoader ? (
                <Spinner />
              ) : (
                <>
                  <DraftIcon className="mr-[6px]" />
                  Save, Move to Drafts
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditPost;
